import { IntlShape } from 'react-intl';

import { documentsTitle, documentSubTitles } from './DocumentTypes.messages';
import { DocRequirementTypes, TOffersDataRequirements } from '../types';

export function generateCopyStringBody({
    requiredDocs,
    optionalDocs,
    intl
}: {
    requiredDocs?: TOffersDataRequirements[number]['actions'];
    optionalDocs?: TOffersDataRequirements[number]['actions'];
    intl: IntlShape;
}) {
    let requiredBodyText;
    if (requiredDocs) {
        requiredBodyText = generateBodyTextString({
            docRequirements: requiredDocs,
            newLineBreak: '\n',
            intl
        });
    }

    let optionalBodyText = '';
    if (optionalDocs) {
        optionalBodyText = generateBodyTextString({
            docRequirements: optionalDocs,
            newLineBreak: '\n',
            intl
        });
    }

    return `${requiredBodyText}${optionalBodyText}`;
}

export function generateBodyTextString({
    docRequirements,
    newLineBreak,
    intl
}: {
    docRequirements: TOffersDataRequirements[number]['actions'];
    newLineBreak: string;
    intl: IntlShape;
}) {
    const text = docRequirements.map((requirement) => {
        const title = requirementsTitle(
            requirement.type as DocRequirementTypes,
            requirement.quantifier.value,
            intl
        );

        return `${title} ${
            requirement.is_optional ? '(optional)' : ''
        }${newLineBreak}`;
    });

    return text.join('');
}

export const requirementsTitle = function (
    type: DocRequirementTypes,
    quantifier: number,
    intl: IntlShape
) {
    switch (type) {
        case 'company_accounts':
            return intl.formatMessage({
                ...documentsTitle['business_accounts']
            });
        case 'bank_statement':
            if (quantifier) {
                return intl.formatMessage(
                    {
                        ...documentsTitle['bank_statement_with_quantifier']
                    },
                    { quantifier }
                );
            }
            return intl.formatMessage({
                ...documentsTitle['bank_statement']
            });
        case 'vat_return':
            const quarter = quantifier / 3;
            if (quarter > 1) {
                return intl.formatMessage(
                    {
                        ...documentsTitle['vat_return_with_quantifier']
                    },
                    { quantifier: quarter }
                );
            }
            return intl.formatMessage({
                ...documentsTitle['vat_return']
            });
        case 'jaehrliche_bwa_susa_hochladen':
            return intl.formatMessage(
                {
                    ...documentsTitle['jaehrliche_bwa_susa_hochladen']
                },
                {
                    quantifier: quantifier
                }
            );
        default:
            return intl.formatMessage({
                ...documentsTitle[type]
            });
    }
};

export type availableSubTitlesType =
    | 'management_accounts'
    | 'aged_debtor_report'
    | 'bank_statement'
    | 'vat_return'
    | 'kontoauszuege_hochladen'
    | 'jaehrliche_bwa_susa_hochladen';

export const requirementsSubTitle = function (
    type: availableSubTitlesType,
    quantifier: number,
    intl: IntlShape
) {
    switch (type) {
        case 'bank_statement':
            if (quantifier) {
                return intl.formatMessage(
                    {
                        ...documentSubTitles['bank_statement_with_quantifier']
                    },
                    { quantifier }
                );
            }
            return intl.formatMessage({
                ...documentSubTitles['bank_statement']
            });
        case 'vat_return':
            const quarter = quantifier / 3;
            if (quarter > 1) {
                return intl.formatMessage(
                    {
                        ...documentSubTitles['vat_return_with_quantifier']
                    },
                    { quantifier: quarter }
                );
            }
            return intl.formatMessage({
                ...documentSubTitles['vat_return']
            });
        default:
            return documentSubTitles[type]
                ? intl.formatMessage({
                      ...documentSubTitles[type]
                  })
                : '';
    }
};
